import supabase from './supabase'

export async function createPublicLead({
  name,
  email,
  phone,
  subject,
  message,
  serviceId = null,
  source = 'website'
}) {
  const { data, error } = await supabase.rpc('codevaro_public_lead_create', {
    p_name: name?.trim() || '',
    p_email: email?.trim() || null,
    p_phone: phone?.trim() || null,
    p_subject: subject?.trim() || null,
    p_message: message?.trim() || null,
    p_service_id: serviceId || null,
    p_source: source
  })

  if (error) throw error
  return data?.[0]?.lead_id || null
}